export default {
  SET_COMPANY_LOGO(state, logo) {
    state.logo = logo;
  },
};
